import { FC } from "react";
import { SanityMainImage } from "../../graphql-types";
import { buildImageObj, cn } from "../lib/helpers";
import { imageUrlFor } from "../lib/image-url";
import * as styles from "./Image.module.scss";

export interface ImageProps {
  image: SanityMainImage;
  hasRoundedCorners?: boolean;
  fullQuality?: boolean;
  className?: string;
}

const Image: FC<ImageProps> = ({
  image,
  className,
  fullQuality = false,
  hasRoundedCorners = true,
}) => {
  const optimizedUrl = imageUrlFor(buildImageObj(image))
    .auto("format")
    .fit("max")
    .width(840)
    .quality(90)
    .url();
  const fullQualityUrl = imageUrlFor(buildImageObj(image))
    .auto("format")
    .quality(100)
    .url();

  return (
    <img
      className={cn(
        styles.root,
        className,
        hasRoundedCorners ? styles.rounded : ""
      )}
      src={fullQuality ? fullQualityUrl : optimizedUrl}
      alt={image.alt}
    />
  );
};

export default Image;
